import React from 'react'
import { FolderOpenIcon, BookmarkIcon } from '@heroicons/react/24/outline'

export default function SavedSearchControls({
	openModal,
	openNewSearchModal,
	isDarkMode,
}) {
	const btnClasses = `inline-flex items-center gap-1.5 text-[13px] font-normal leading-none py-1 cursor-pointer transition-colors ${
		isDarkMode
			? 'text-gray-200 hover:text-white'
			: 'text-gray-700 hover:text-gray-900'
	}`

	return (
		<div className="mb-0 flex justify-between md:justify-start md:gap-5 text-sm ml-1 md:ml-0 w-full md:w-auto">
			<button className={btnClasses} onClick={openModal}>
				<FolderOpenIcon className="h-4 w-4" />
				Saved Searches
			</button>
			<button className={btnClasses} onClick={openNewSearchModal}>
				<BookmarkIcon className="h-4 w-4" />
				Save This Search
			</button>
		</div>
	)
}
